var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 19.9537C17.3711 16.8048 21.5247 15 25.8256 15C43.8098 15 59.2724 46.5652 66.1141 75.7624",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 29.125C6.09441 27.6081 7.22084 26.1873 8.36645 24.8689",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.098 56.9846C108.582 56.9846 115.459 50.1076 115.459 41.6244C115.459 33.1412 108.582 26.2642 100.098 26.2642C91.6153 26.2642 84.7383 33.1412 84.7383 41.6244C84.7383 50.1076 91.6153 56.9846 100.098 56.9846Z",
    fill: "#FD6533"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8513 47.378C78.7024 34.1938 93.2882 20.056 106.536 26.4497C110.344 28.2673 113.378 31.7938 114.338 35.8706C110.46 29.0289 102.044 25.7521 94.8818 28.7153C87.6689 31.5506 83.8865 39.7619 85.8577 47.378H85.8513Z",
    fill: "#FEA183"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7988 104.601H47.8792",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0412 104.601H8.20117",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.961 40.6003L95.8809 59.1606",
    stroke: "white",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1082 48.8052L81.0137 66.9622",
    stroke: "white",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2617 93.6506C72.5466 79.4104 78.7995 62.3158 86.8892 54.2133",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3203 104.281C69.3203 102.668 69.4035 100.947 69.5635 99.1484",
    stroke: "#2E4D69",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2013 50.1044L89.0332 59.4933",
    stroke: "#FD6533",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.522 41.2404L98.4414 59.8006",
    stroke: "#FD6533",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4811 30.3602L77.9609 45.0804",
    stroke: "#FEA183",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1217 41.2404L78.6016 55.9606",
    stroke: "#FD6533",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7421 103.43C37.0447 103.43 42.9647 97.5102 42.9647 90.2076C42.9647 82.9049 37.0447 76.985 29.7421 76.985C22.4395 76.985 16.5195 82.9049 16.5195 90.2076C16.5195 97.5102 22.4395 103.43 29.7421 103.43Z",
    fill: "#36CCC1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4812 95.1612C11.0236 83.7499 23.8429 71.3529 35.3503 76.9914C38.6399 78.6042 41.2576 81.7018 42 85.2539C38.5375 79.4874 31.4334 76.7674 25.3214 79.2826C19.1773 81.7146 15.9516 88.6075 17.4748 95.1612H17.4812Z",
    fill: "#8BE2DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotA);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;